export default function parseReportFilename(contentDisposition, fallback = 'operation-report.csv') {
  if (!contentDisposition || typeof contentDisposition !== 'string') {
    return fallback;
  }

  const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition);
  if (utf8Match) {
    try {
      return decodeURIComponent(utf8Match[1].trim());
    } catch (error) {
      return utf8Match[1].trim();
    }
  }

  const quotedMatch = /filename="([^"]+)"/i.exec(contentDisposition);
  if (quotedMatch) {
    return quotedMatch[1];
  }

  const plainMatch = /filename=([^;]+)/i.exec(contentDisposition);
  if (plainMatch) {
    return plainMatch[1].trim().replace(/^["']|["']$/g, '');
  }

  return fallback;
}
